import React from 'react';

export default function VideoEmbed({ heading, videoUrl, caption }) {
  const lang = localStorage.getItem('language') || 'arm';
  const headingStr = heading ? (heading[lang] || heading.en || '') : '';
  const captionStr = caption ? (caption[lang] || caption.en || '') : '';

  if (!videoUrl) return null;

  return (
    <section className='video-section text-center py-4'>
      {headingStr && <h3 className='mb-3'>{headingStr}</h3>}
      <iframe
        src={videoUrl}
        title={headingStr || 'video'}
        width='100%'
        height='500'
        frameBorder='0'
        allow='autoplay; encrypted-media'
        allowFullScreen
      />
      {captionStr && <p className='mt-2 text-muted'>{captionStr}</p>}
    </section>
  );
}
